export default function PrintStream() {}